export default __webpack_public_path__ + "static/media/a037-5.3c9b808d.svg";